export const translations = {
    en: {
        nav: {
            promo: "Promo: Invite Friends",
            signup: "Sign up",
            login: "Login"
        },
        sections: {
            seamlessTrading: "Seamless Trading Experience",
            easyDeposits: "Easy Deposits & Quick Withdrawals",
            trustedPlatform: "Stockity - Trade Smart and Safe!",
            choosePayment: "Choose from Multiple Payment Methods",
            createAccount: "Create Your Account Today",
            fastEasy: "Fast & Easy"
        },
        hero: {
            title: "Stockity - Trade Smart and Safe!",
            description: "Awarded \"Most Reliable Trading Platform\" in Indonesia 2024 — Security, Speed, and Innovation You Can Trust.",
            demo: "Create Your Account Today",
            features: {
                globalReach: {
                    title: "Global Reach",
                    description: "Over 1 Million Active Traders Worldwide Daily"
                },
                simplicity: {
                    title: "Simplicity at its Best",
                    description: "Intuitive Interface & Powerful Trading Tools"
                },
                flexibility: {
                    title: "Ultimate Flexibility",
                    description: "Trade Anytime, Anywhere — Desktop & App Available"
                }
            }
        },
        mobileApp: {
            title: "Trade Anywhere You Are",
            description: "Download our mobile app. Make every queue, traffic jam, and coffee break productive for you!",
            downloadAndroid: "Download Android APK"
        },
        referral: {
            title: "Sign up, invite friends, and get up to $100",
            description: "After signing up and making a deposit, you can invite friends and receive $10 to $20 to your real account for each person, depending on your status",
            vipAmount: "$20",
            vipText: "VIP and Platinum traders receive for each new trader",
            standardAmount: "$10",
            standardText: "Standard and Gold traders receive for each new trader",
            maximizeTitle: "Maximize your profits with the referral program:",
            steps: {
                step1: "Find friends who are already trading on Stockity",
                step2: "Sign up with their referral link",
                step3: "Make a deposit and get $10 for it",
                step4: "Invite friends and get up to $100 more"
            },
            learnMore: "Learn More"
        },
        payments: {
            title: "Easy Deposits & Quick Withdrawals",
            subtitle: "Choose from Multiple Payment Methods",
            methods: {
                qris: "QRIS Payments",
                dana: "Direct Fund Transfers",
                virtual: "Virtual Account Options",
                internet: "Internet Banking Available",
                ovo: "Pay via OVO",
                shopee: "Shopee Pay Support"
            }
        },
        trusted: {
            title: "Stockity - Trade Smart and Safe!",
            subtitle: "Awarded \"Most Reliable Trading Platform\" in Indonesia 2024 — Security, Speed, and Innovation You Can Trust."
        },
        trading: {
            demo: {
                amount: "$10,000",
                title: "Demo Account Access",
                description: "Practice risk-free with a $10,000 demo account. Explore strategies, understand market dynamics, and sharpen your skills before investing real money."
            },
            start: {
                amount: "$10",
                title: "Start with Just $10",
                description: "Launch your trading career with a minimum deposit of only $10— perfect for learning without big financial risks."
            },
            lowEntry: {
                amount: "$1",
                title: "Low Entry — $1 Trades",
                description: "Start trading with as little as $1 per trade — ideal for beginners to practice and build confidence affordably."
            },
            support: {
                title: "24/7 Dedicated Support",
                description: "Questions? Our expert support team is available 24/7 via email or live chat to assist you anytime."
            },
            tools: {
                title: "30+ Advanced Analytic Tools",
                description: "Empower your trading with 30+ advanced indicators and charting tools to make smarter, data-driven decisions."
            },
            education: {
                title: "Free Comprehensive Education",
                description: "Unlock free access to premium educational resources. Learn strategies, sharpen your skills, and maximize your trading potential."
            }
        },
        footer: {
            rights: "All rights reserved."
        }
    },
    id: {
        nav: {
            promo: "Promo: Ajak Teman",
            signup: "Daftar",
            login: "Masuk"
        },
        sections: {
            seamlessTrading: "Pengalaman Trading yang Mulus",
            easyDeposits: "Deposit Mudah & Penarikan Cepat",
            trustedPlatform: "Stockity: Dipercaya oleh Para Profesional Trading!",
            choosePayment: "Pilih dari Berbagai Metode Pembayaran",
            createAccount: "Daftar Sekarang",
            fastEasy: "Cepat & Mudah"
        },
        hero: {
            title: "Stockity - Trading Cerdas dan Aman",
            description: "Dianugerahi \"Platform Trading Paling Terpercaya\" di Indonesia 2024 — Keamanan, Kecepatan, dan Inovasi yang Dapat Anda Percaya.",
            demo: "Daftar Sekarang",
            features: {
                globalReach: {
                    title: "Jangkauan Global",
                    description: "Lebih dari 1 Juta Trader Aktif Setiap Hari"
                },
                simplicity: {
                    title: "Kemudahan Maksimal",
                    description: "Antarmuka Intuitif & Alat Trading Powerful"
                },
                flexibility: {
                    title: "Fleksibilitas Tanpa Batas",
                    description: "Trading Kapan Saja, Dimana Saja — Desktop & Aplikasi"
                }
            }
        },
        mobileApp: {
            title: "Trading di mana pun Anda berada",
            description: "Unduh aplikasi seluler kami. Buat setiap antrean, kemacetan lalu lintas, dan minum-minum kopi menjadi produktif untuk Anda!"
        },
        referral: {
            title: "Daftar, undang teman, dan dapatkan hingga $100",
            description: "Setelah mendaftar dan melakukan deposit, Anda dapat mengundang teman dan menerima $10 hingga $20 ke akun riil Anda untuk setiap orang, bergantung pada status Anda",
            vipAmount: "$20",
            vipText: "Yang trader VIP dan Platinum terima untuk setiap trader baru",
            standardAmount: "$10",
            standardText: "Yang trader Standard dan Gold terima untuk setiap trader baru",
            maximizeTitle: "Maksimalkan keuntungan Anda dengan program rujukan:",
            steps: {
                step1: "Temukan teman yang sudah berdagang di Stockity",
                step2: "Daftar dengan tautan rujukan mereka",
                step3: "Lakukan deposit dan dapatkan $10 untuk itu",
                step4: "Undang teman dan dapatkan hingga $100 lebih"
            },
            learnMore: "Selengkapnya"
        },
        payments: {
            title: "Deposit Mudah & Penarikan Cepat",
            subtitle: "Pilih dari Berbagai Metode Pembayaran",
            methods: {
                qris: "Pembayaran QRIS",
                dana: "Transfer Dana Langsung",
                virtual: "Opsi Akun Virtual",
                internet: "Internet Banking Tersedia",
                ovo: "Bayar via OVO",
                shopee: "Dukungan Shopee Pay"
            }
        },
        trusted: {
            title: "Stockity - Trading Cerdas dan Aman",
            subtitle: "Dianugerahi \"Platform Trading Paling Terpercaya\" di Indonesia 2024 — Keamanan, Kecepatan, dan Inovasi yang Dapat Anda Percaya."
        },
        trading: {
            demo: {
                amount: "$10,000",
                title: "Akses Akun Demo",
                description: "Berlatih tanpa risiko dengan akun demo $10,000. Jelajahi strategi, pahami dinamika pasar, dan asah keterampilan Anda sebelum berinvestasi uang sungguhan."
            },
            start: {
                amount: "$10",
                title: "Mulai Hanya dengan $10",
                description: "Mulai karir trading Anda dengan deposit minimal hanya $10— sempurna untuk belajar tanpa risiko finansial besar."
            },
            lowEntry: {
                amount: "$1",
                title: "Entry Rendah — Trade $1",
                description: "Mulai trading dengan minimal $1 per trade — ideal bagi pemula untuk berlatih dan membangun kepercayaan diri dengan terjangkau."
            },
            support: {
                title: "Dukungan 24/7",
                description: "Ada pertanyaan? Tim support ahli kami tersedia 24/7 melalui email atau live chat untuk membantu Anda kapan saja."
            },
            tools: {
                title: "30+ Alat Analisis Lanjutan",
                description: "Perkuat trading Anda dengan 30+ indikator dan alat charting lanjutan untuk membuat keputusan lebih cerdas berbasis data."
            },
            education: {
                title: "Edukasi Komprehensif Gratis",
                description: "Dapatkan akses gratis ke sumber daya edukasi premium. Pelajari strategi, asah keterampilan, dan maksimalkan potensi trading Anda."
            }
        },
        footer: {
            rights: "Seluruh hak cipta dilindungi."
        }
    }
}; 